//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import healthyNotifies from '../data/healthyNotifies'

export default {
  name: 'm-notify',
  mounted () {
    this.$store.commit('updateProductId', this.$route.params.productId)
    this.$store.commit('updateUserId', this.$route.params.userId)
    // this.$store.commit('updateOrderOpenId', this.$route.params.openId)
    document.title = '被保险人告知'
  },
  data () {
    return {
      fit: '',
      notifies: healthyNotifies
    }
  },
  methods: {
    next () {
      if (this.fit !== true && this.fit !== false) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请确认被保险人是否具有以上情况',
          position: 'top',
          width: '20em'
        })
        return
      }
      if (this.fit === false) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，您的告知不符合投保要求，谢谢惠顾',
          position: 'top',
          width: '20em'
        })
        return
      }
      this.$router.push({name: 'Form', params: {productId: this.$store.state.order.productId, userId: this.$store.state.order.userId}, query: this.$route.query})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Notify.vue